var _g;
import * as React from "react";
var SvgButtonStagePause = function SvgButtonStagePause(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F2F0",
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.000000, 15.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 5,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 0,
    width: 5,
    height: 17
  })))));
};
export default SvgButtonStagePause;